/**
*
* AjaxSpinner
*
*/


function AjaxSpinner(props) {

    return (
      <>
      <div style={{ "position": "absolute" , "top": "00px", "left": "0px" }} >
        THIS IS AJAX SPINNER
      </div>
    </>
    )  
   
}

export default AjaxSpinner
